const MobileMenu = ({ isOpen, onClose }) => {
  return (
    <div
      className={`
        md:hidden overflow-hidden transition-[max-height] duration-300 ease-in-out
        ${isOpen ? "max-h-48" : "max-h-0"}
      `}
    >
      <nav className="py-4 bg-white">
        <div className="flex flex-col space-y-4">
          <a
            href="#about"
            className="hover:text-blue-600 transition-colors"
            onClick={onClose}
          >
            About
          </a>
          <a
            href="#skills"
            className="hover:text-blue-600 transition-colors"
            onClick={onClose}
          >
            Skills
          </a>
          <a
            href="#certifications"
            className="hover:text-blue-600 transition-colors"
            onClick={onClose}
          >
            Certifications
          </a>
          <a
            href="#contact"
            className="hover:text-blue-600 transition-colors"
            onClick={onClose}
          >
            Contact
          </a>
        </div>
      </nav>
    </div>
  );
};

export default MobileMenu;
